import React from 'react';
import {
  Box,
  VStack,
  HStack,
  Text,
  Heading,
  Card,
  CardBody,
  Image
} from '@chakra-ui/react';

// Prize configuration - add more prizes to this array as needed
const PRIZES = [
  {
    imageSrc: '/amazon-gift-card.png',
    fallbackBg: '#232F3E',
    title: 'Amazon Gift Card',
    alt: 'Amazon Gift Card Prize',
    fallbackText: 'amazon'
  },
  {
    imageSrc: '/bigboy-balm.png',
    fallbackBg: 'black',
    title: 'BigBoyBalm.com Gift Card',
    alt: 'Big Boy Balm Gift Card Prize',
    fallbackText: 'BIG BOY BALM'
  },
  {
    imageSrc: '/combat-corner-hand-wraps.png',
    fallbackBg: 'black',
    title: 'Gel Hand Wraps',
    alt: 'Gel Hand Wraps Prize',
    fallbackText: 'GEL HAND WRAPS'
  }
  // Add more prizes here as needed
  // {
  //   imageSrc: '/prize-3.png',
  //   fallbackBg: '#your-color',
  //   title: 'Prize Title',
  //   alt: 'Prize Alt Text',
  //   fallbackText: 'PRIZE TEXT'
  // }
];

export const PrizeShowcase = () => {
  return (
    <Card
      mb={6}
      bg="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
      borderWidth={3}
      borderColor="gold"
      boxShadow="0 0 30px rgba(255, 215, 0, 0.3)"
    >
      <CardBody py={6}>
        <VStack spacing={0}>
          {/* Header */}
          <Heading
            size={{ base: "md", md: "lg" }}
            color="white"
            textAlign="center"
            textShadow="2px 2px 4px rgba(0,0,0,0.3)"
          >
            🏆 Vote to Win Amazing Prizes! 🏆
          </Heading>

          <Text
            color="white"
            fontSize={{ base: "sm", md: "md" }}
            textAlign="center"
            fontWeight="medium"
            maxW="600px"
          >
            Cast your votes and compete for a chance to win exclusive prizes!
          </Text>

          {/* Prize Images - Rotating */}
          <HStack
            spacing={{ base: 6, md: 12 }}
            justify="center"
            align="center"
            pt={4}
            flexWrap={{ base: "wrap", md: "nowrap" }}
          >
            {PRIZES.map((prize, index) => (
              <VStack key={index} spacing={3}>
                <Box
                  sx={{
                    '@keyframes rotate3D': {
                      '0%': {
                        transform: 'perspective(1000px) rotateY(0deg)'
                      },
                      '100%': {
                        transform: 'perspective(1000px) rotateY(360deg)'
                      }
                    },
                    animation: 'rotate3D 8s linear infinite',
                    animationDelay: `${index * 4}s`,
                    '&:hover': {
                      animationPlayState: 'paused'
                    }
                  }}
                  cursor="pointer"
                >
                  <Box
                    width={{ base: "120px", md: "180px" }}
                    height={{ base: "auto", md: "auto" }}
                    minHeight={{ base: "120px", md: "180px" }}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    position="relative"
                  >
                    <Image
                      src={prize.imageSrc}
                      alt={prize.alt}
                      maxWidth={{ base: "120px", md: "180px" }}
                      width="100%"
                      height="auto"
                      objectFit="contain"
                      loading="lazy"
                      fallback={
                        <Box
                          width={{ base: "120px", md: "180px" }}
                          height={{ base: "120px", md: "180px" }}
                          bg={prize.fallbackBg}
                          borderRadius="lg"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          boxShadow="0 4px 20px rgba(0,0,0,0.3)"
                        >
                          <VStack spacing={1} p={3}>
                            <Text
                              fontSize={index === 0 ? "2xl" : "lg"}
                              color={index === 0 ? "#FF9900" : "white"}
                              fontWeight={index === 0 ? "normal" : "black"}
                              textAlign="center"
                              lineHeight="short"
                            >
                              {prize.fallbackText}
                            </Text>
                            {index === 0 && (
                              <Text fontSize="xs" color="white" fontWeight="bold">
                                Gift Card
                              </Text>
                            )}
                          </VStack>
                        </Box>
                      }
                    />
                  </Box>
                </Box>
                <Text
                  color="white"
                  fontSize={{ base: "xs", md: "sm" }}
                  fontWeight="bold"
                  textAlign="center"
                >
                  {prize.title}
                </Text>
              </VStack>
            ))}
          </HStack>

          {/* Call to Action */}
          <Text
            color="yellow.200"
            fontSize={{ base: "xs", md: "sm" }}
            textAlign="center"
            fontWeight="medium"
            fontStyle="italic"
            pt={2}
          >
            ✨ Make your predictions and climb the leaderboard! ✨
          </Text>
        </VStack>
      </CardBody>
    </Card>
  );
};

